import { CarouselManager } from "../utils/carouselManager";

class ProductGallery extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    await this.initSlider();
    this.initSliderArrows();
  }

  async initSlider() {
    const splideEl = this.querySelector(".splide");

    let options = {
      type: "fade",
      perPage: 1,
      pagination: true,
      arrows: false,
    };

    // Let CarouselManager handle initialization and observation
    this.splide = await CarouselManager.create(splideEl, options);
    if (this.dataset.lazyloadSection === "true") {
      await this.fetchItems();
      if(this.splide) {
        this.splide.refresh();
      }
    }

    if (this.dataset.arrows === "true") {
      this.initSliderArrows();
    }
    this.classList.add("js-loaded");
  }

  initSliderArrows() {
    const sliderNavEl = this.querySelector(".slider-nav");
    if (sliderNavEl) {
      const navNextBtn = sliderNavEl.querySelector(".nav-next");
      const navPrevBtn = sliderNavEl.querySelector(".nav-prev");

      const maxIndex = () => {
        const maxIndex = this.splide.Components.Controller.getEnd() - this.visibleSlides + 1;
        const currentIndex = this.splide.Components.Controller.getIndex();
        
        if(maxIndex === currentIndex) {
          return true;
        } else if(maxIndex < currentIndex) {
          this.splide.Components.Controller.setIndex(maxIndex);
          return true;
        } else {
          return false;
        }
      }

      navNextBtn.addEventListener("click", () => {
        if(maxIndex()) return;
        this.splide.go(">");
      });

      navPrevBtn.addEventListener("click", () => {
        maxIndex();
        this.splide.go("<");
      });
    } else {
      console.warn("No slider nav found");
    }
  }

  get visibleSlides() {
    if (!this.splide) return 1;
    if(!this._visibleSlides || this._windowWidth !== window.innerWidth) {
      this._windowWidth = window.innerWidth;
      this._visibleSlides = this.splide.root.querySelectorAll(".splide__slide.is-visible").length
    }
    return this._visibleSlides;
  }
}

customElements.define('product-gallery', ProductGallery);